<div class="row" *ngIf="subject">
  <!-- *ngIf="subject" -->
  <div class="col-12 d-flex">
    <div class="pl-1 pt-1 headersize">Target Location:</div>
    <div class="p-0 headersize">
      <app-breadcrumb
        [Breadcrumblist]="Breadcrumblist"
        ReorderTopic="{{ currentsubject.Subject_Name }}"
      ></app-breadcrumb>
      <!-- ReorderTopic="{{currentsubject.Subject_Name}}" -->
    </div>
    <!-- <div class="p-0 pt-1 element">{{currentsubject.Subject_Name}}</div> -->
  </div>
  <div class="col-12" style="min-height: 48vh !important; overflow-y: scroll">
    <div class="row">
      <div class="col-12 pb-1">
        {{ getparentselected() }}
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_majorTopic"
          [hidden]="!majorTopic"
          (ngModelChange)="getsubject('C', mdl_majorTopic, $event)"
        >
          <option selected [ngValue]="0"></option>
          <option
            class="border-bottom"
            *ngFor="let s of majorTopic"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_majorTopic == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_majorTopic == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_concept"
          [hidden]="!concept"
          (ngModelChange)="getsubject('SC1', mdl_concept, $event)"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of concept"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id || (mdl_concept == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_concept == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_subconcept1"
          [hidden]="!subconcept1"
          (ngModelChange)="getsubject('SC2', mdl_subconcept1, $event)"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of subconcept1"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_subconcept1 == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_subconcept1 == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_subconcept2"
          [hidden]="!subconcept2"
          (ngModelChange)="getsubject('SC3', mdl_subconcept2, $event)"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of subconcept2"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_subconcept2 == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_subconcept2 == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_subconcept3"
          [hidden]="!subconcept3"
          (ngModelChange)="getsubject('SC4', mdl_subconcept3, $event)"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of subconcept3"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_subconcept3 == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_subconcept3 == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_subconcept4"
          [hidden]="!subconcept4"
          (ngModelChange)="getsubject('SC5', mdl_subconcept4, $event)"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of subconcept4"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_subconcept4 == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_subconcept4 == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_subconcept5"
          [hidden]="!subconcept5"
          (ngModelChange)="getsubject('SC6', mdl_subconcept5, $event)"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of subconcept5"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_subconcept5 == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_subconcept5 == 0 && s.ID==0)" -->
        </select>
      </div>
      <div class="col-12 pb-1">
        <select
          class="form-control form-control-sm input-txt"
          [(ngModel)]="mdl_subconcept6"
          [hidden]="!subconcept6"
        >
          <option selected [ngValue]="0"></option>

          <option
            class="border-bottom"
            *ngFor="let s of subconcept6"
            [ngValue]="s"
            [hidden]="
              s.ID === subjectById.Subject_Id ||
              (mdl_subconcept6 == 0 && s.ID == 0)
            "
          >
            {{ s.Name }}
          </option>
          <!-- [hidden]="s.ID === SubjectParentInput.Subject_Id || (mdl_subconcept6 == 0 && s.ID==0)" -->
        </select>
      </div>
    </div>
  </div>
  <div class="col-12 d-flex p-1 pt-3 border-top mt-3">
    <div class="px-1">
      <button
        type="button"
        class="btn btn-sm bl-btn"
        [disabled]="currentselectedvalue == 'Y' || !currentselectedvalue"
        (click)="relocateFlashCard()"
      >
        Save
      </button>
      <!-- (click)="AddQuestionHeader()" -->
    </div>
    <div class="px-1">
      <button
        type="button"
        class="btn btn-sm bg-light border"
        (click)="Cancel()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
